export default "__VITE_ASSET__CrvTZP7b__"